// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ValueDisplayBoxes_Wrapper__2xGoP","Unit":"ValueDisplayBoxes_Unit__1phwL"};